import { useEffect, useState } from "react";
import { Button, Input, Label } from "reactstrap";
import { fileUploadHandler } from "../../../lib/utils";
import { useAppSelector } from "../../../reduxToolkit/hooks";

interface UploadModalContentProps {
  setUploadSuccess: (success: boolean) => void;
  setShowConfirm: (show: boolean) => void;
  close: () => void;
}

const UploadModalContent = ({
  setUploadSuccess,
  setShowConfirm,
  close,
}: UploadModalContentProps) => {
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [open, setOpen] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [isValidLink, setIsValidLink] = useState(false);
  // Adjust the selector to match your actual Redux state structure
  const token = useAppSelector((state: any) => state.auth?.token);
  const checkIfValidLink = (link: string) => {
    return (
      (typeof link === "string" &&
        link.includes("https") &&
        link.includes("://") &&
        link.includes("youtube.com")) ||
      link.startsWith("https://youtu.be/")
    );
  };

  useEffect(() => {
    setIsValidLink(checkIfValidLink(fileLink));
  }, [fileLink]);
  return (
    <div className="upload-file-modal-content">
      <h2 className="text-lg font-semibold mb-4">Upload Video</h2>
      <Input
        type="file"
        accept="video/*"
        onChange={(e) => {
          const files = e.target.files;
          setFile(files && files.length > 0 ? files[0] : null);
        }}
        className="mb-4"
      />
      <Label className="flex flex-col w-full gap-2">
        Add youtube link to video
        <Input
          className="w-full"
          placeholder="https://www.youtube.com/watch?v=example"
          type="text"
          value={fileLink}
          onChange={(e) => setFileLink(e.target.value)}
        />
      </Label>
      <Button
        variant="primary"
        disabled={!isValidLink || !file || uploading}
        className={`mt-4 ${
          uploading ? "cursor-not-allowed" : ""
        } bg-green-200 hover:bg-green-300`}
        onClick={async () => {
          if (!file) return;
          setUploading(true);
          try {
            const uploadRes = await fileUploadHandler(file, fileLink, token);
            if (uploadRes.uploaded) {
              setUploadSuccess(true);
              setUploading(false);
              setOpen(false);
              setShowConfirm(true);
            } else {
              setUploadSuccess(false);
              setUploading(false);
              setOpen(false);
              setShowConfirm(true);
            }
          } catch (error) {
            setUploadSuccess(false);
            setUploading(false);
            setOpen(false);
            setShowConfirm(true);
            console.error("Error uploading file:", error);
          } finally {
            // setUploading(false);
            // setOpen(false);
            setFile(null);
            setIsValidLink(false);
            setFileLink("");
            close();
          }
        }}
      >
        {uploading ? "Uploading..." : "Upload"}
      </Button>
    </div>
  );
};
export default UploadModalContent;
